// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.am-card {
  background: linear-gradient(180deg, #ffffff, #fbfbfb);
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(32, 40, 60, 0.08);
  padding: 14px;
  border: 1px solid rgba(16, 24, 40, 0.04);
  font-family:
    system-ui,
    -apple-system,
    "Segoe UI",
    Roboto,
    Arial;
  color: #111827;
  width: 950px;
}

.am-ticker {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: linear-gradient(90deg, #f0f9ff, #f8fafc);
  border-radius: 10px;
  min-height: 56px;
  box-shadow: 0 4px 12px rgba(2, 6, 23, 0.04);
}

.am-icon {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #787f82, #727272);
  color: #fff;
  font-weight: 600;
  border-radius: 8px;
}

.am-ticker-text {
  font-size: 15px;
  line-height: 1.2;
  color: #0f172a;
  animation: amFade 360ms ease;
}

@keyframes amFade {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.am-muted {
  opacity: 0.65;
  font-size: 13px;
}

.am-form {
  margin-top: 14px;
  display: flex;
  gap: 12px;
  align-items: center;
}

.am-input {
  flex: 1 1;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid rgba(15, 23, 42, 0.06);
  outline: none;
}

.am-controls {
  display: flex;
  gap: 8px;
}

.am-btn {
  padding: 8px 12px;
  border-radius: 10px;
  background: #f3f4f6;
  border: none;
  cursor: pointer;
}

.am-btn-primary {
  background: linear-gradient(180deg, #616161, #636363);
  color: #fff;
}

.am-btn-ghost {
  background: transparent;
  border: 1px solid rgba(15, 23, 42, 0.06);
}

.am-list {
  margin-top: 12px;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid rgba(15, 23, 42, 0.04);
  background: #fff;
}

.am-list-item {
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid rgba(15, 23, 42, 0.03);
}

.am-list-item:last-child {
  border-bottom: none;
}

.am-action {
  display: flex;
  gap: 8px;
}

/* Rich text editor */
.am-editor {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
}

.am-editor-toolbar {
  display: flex;
  gap: 6px;
  padding: 8px;
  background: #f9fafb;
  border-bottom: 1px solid rgba(15, 23, 42, 0.05);
}

.am-editor-btn {
  padding: 6px 10px;
  border-radius: 8px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  background: #ffffff;
  cursor: pointer;
  font-weight: 600;
}

.am-editor-btn:hover {
  background: #f3f4f6;
}

.am-editor-select {
  margin-left: auto;
  padding: 6px 8px;
  border-radius: 8px;
  border: 1px solid rgba(15, 23, 42, 0.08);
}

.am-editor-content {
  min-height: 90px;
  padding: 12px;
  outline: none;
  font-size: 14px;
  line-height: 1.4;
}
/* Placeholder for contentEditable */
.am-editor-content:empty::before {
  content: attr(data-placeholder);
  color: #9ca3af;
  pointer-events: none;
  display: block;
}

/* When focused, keep placeholder subtle */
.am-editor-content:focus:empty::before {
  color: #cbd5f5;
}

/* LIVE TICKER */

.am-live-wrapper {
  margin-top: 20px;
}

/* Main bar */
.am-live-ticker {
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  gap: 14px;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

/* ACTIVE */
.am-live-ticker.live {
  background: linear-gradient(90deg, #111827, #1f2937);
  color: white;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
}

/* INACTIVE */
.am-live-ticker.inactive {
  background: #f3f4f6;
  color: #6b7280;
}

/* LIVE badge */
.am-live-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1px;
  padding: 6px 10px;
  border-radius: 999px;
  background: #ef4444;
  color: white;
}

/* marquee container */
.am-marquee {
  flex: 1 1;
  overflow: hidden;
  position: relative;
}

/* Wrapper */
.am-announcement-preview {
  margin-top: 20px;
}

/* Main Bar */
.am-announcement {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 18px;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.05);
  transition: 0.25s;
}

/* Hover feel */
.am-announcement:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.08);
}

/* Active dot */
.am-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #22c55e;
  box-shadow: 0 0 0 4px rgba(34, 197, 94, 0.15);
}

/* Text */
.am-announcement-text {
  flex: 1 1;
  font-size: 15px;
  color: #111827;
}

/* Status badge */
.am-status {
  font-size: 12px;
  font-weight: 600;
  padding: 6px 10px;
  border-radius: 999px;
  background: #ecfdf5;
  color: #16a34a;
}

/* INACTIVE */
.am-announcement.inactive {
  opacity: 0.6;
}

.am-announcement.inactive .am-dot {
  background: #9ca3af;
  box-shadow: none;
}

.am-announcement.inactive .am-status {
  background: #f3f4f6;
  color: #6b7280;
}

`, "",{"version":3,"sources":["webpack://./src/features/AnnounceMentTicker/tickerstyle.css"],"names":[],"mappings":"AAAA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,6CAA6C;EAC7C,aAAa;EACb,wCAAwC;EACxC;;;;;SAKO;EACP,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,oDAAoD;EACpD,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qDAAqD;EACrD,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qDAAqD;EACrD,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,qBAAqB;AACrB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;AACA,oCAAoC;AACpC;EACE,+BAA+B;EAC/B,cAAc;EACd,oBAAoB;EACpB,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE,cAAc;AAChB;;AAEA,gBAAgB;;AAEhB;EACE,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qCAAqC;AACvC;;AAEA,WAAW;AACX;EACE,oDAAoD;EACpD,YAAY;EACZ,2CAA2C;AAC7C;;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,qCAAqC;EACrC,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA,eAAe;AACf;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA,SAAS;AACT;EACE,SAAO;EACP,eAAe;EACf,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":[".am-card {\n  background: linear-gradient(180deg, #ffffff, #fbfbfb);\n  border-radius: 12px;\n  box-shadow: 0 6px 18px rgba(32, 40, 60, 0.08);\n  padding: 14px;\n  border: 1px solid rgba(16, 24, 40, 0.04);\n  font-family:\n    system-ui,\n    -apple-system,\n    \"Segoe UI\",\n    Roboto,\n    Arial;\n  color: #111827;\n  width: 950px;\n}\n\n.am-ticker {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  background: linear-gradient(90deg, #f0f9ff, #f8fafc);\n  border-radius: 10px;\n  min-height: 56px;\n  box-shadow: 0 4px 12px rgba(2, 6, 23, 0.04);\n}\n\n.am-icon {\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(180deg, #787f82, #727272);\n  color: #fff;\n  font-weight: 600;\n  border-radius: 8px;\n}\n\n.am-ticker-text {\n  font-size: 15px;\n  line-height: 1.2;\n  color: #0f172a;\n  animation: amFade 360ms ease;\n}\n\n@keyframes amFade {\n  from {\n    opacity: 0;\n    transform: translateY(6px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.am-muted {\n  opacity: 0.65;\n  font-size: 13px;\n}\n\n.am-form {\n  margin-top: 14px;\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.am-input {\n  flex: 1;\n  padding: 10px 12px;\n  border-radius: 10px;\n  border: 1px solid rgba(15, 23, 42, 0.06);\n  outline: none;\n}\n\n.am-controls {\n  display: flex;\n  gap: 8px;\n}\n\n.am-btn {\n  padding: 8px 12px;\n  border-radius: 10px;\n  background: #f3f4f6;\n  border: none;\n  cursor: pointer;\n}\n\n.am-btn-primary {\n  background: linear-gradient(180deg, #616161, #636363);\n  color: #fff;\n}\n\n.am-btn-ghost {\n  background: transparent;\n  border: 1px solid rgba(15, 23, 42, 0.06);\n}\n\n.am-list {\n  margin-top: 12px;\n  border-radius: 10px;\n  overflow: hidden;\n  border: 1px solid rgba(15, 23, 42, 0.04);\n  background: #fff;\n}\n\n.am-list-item {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  padding: 12px;\n  border-bottom: 1px solid rgba(15, 23, 42, 0.03);\n}\n\n.am-list-item:last-child {\n  border-bottom: none;\n}\n\n.am-action {\n  display: flex;\n  gap: 8px;\n}\n\n/* Rich text editor */\n.am-editor {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid rgba(15, 23, 42, 0.06);\n  border-radius: 10px;\n  background: #fff;\n  overflow: hidden;\n}\n\n.am-editor-toolbar {\n  display: flex;\n  gap: 6px;\n  padding: 8px;\n  background: #f9fafb;\n  border-bottom: 1px solid rgba(15, 23, 42, 0.05);\n}\n\n.am-editor-btn {\n  padding: 6px 10px;\n  border-radius: 8px;\n  border: 1px solid rgba(15, 23, 42, 0.08);\n  background: #ffffff;\n  cursor: pointer;\n  font-weight: 600;\n}\n\n.am-editor-btn:hover {\n  background: #f3f4f6;\n}\n\n.am-editor-select {\n  margin-left: auto;\n  padding: 6px 8px;\n  border-radius: 8px;\n  border: 1px solid rgba(15, 23, 42, 0.08);\n}\n\n.am-editor-content {\n  min-height: 90px;\n  padding: 12px;\n  outline: none;\n  font-size: 14px;\n  line-height: 1.4;\n}\n/* Placeholder for contentEditable */\n.am-editor-content:empty::before {\n  content: attr(data-placeholder);\n  color: #9ca3af;\n  pointer-events: none;\n  display: block;\n}\n\n/* When focused, keep placeholder subtle */\n.am-editor-content:focus:empty::before {\n  color: #cbd5f5;\n}\n\n/* LIVE TICKER */\n\n.am-live-wrapper {\n  margin-top: 20px;\n}\n\n/* Main bar */\n.am-live-ticker {\n  position: relative;\n  overflow: hidden;\n  border-radius: 12px;\n  padding: 14px 16px;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n/* ACTIVE */\n.am-live-ticker.live {\n  background: linear-gradient(90deg, #111827, #1f2937);\n  color: white;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);\n}\n\n/* INACTIVE */\n.am-live-ticker.inactive {\n  background: #f3f4f6;\n  color: #6b7280;\n}\n\n/* LIVE badge */\n.am-live-label {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 1px;\n  padding: 6px 10px;\n  border-radius: 999px;\n  background: #ef4444;\n  color: white;\n}\n\n/* marquee container */\n.am-marquee {\n  flex: 1;\n  overflow: hidden;\n  position: relative;\n}\n\n/* Wrapper */\n.am-announcement-preview {\n  margin-top: 20px;\n}\n\n/* Main Bar */\n.am-announcement {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px 18px;\n  border-radius: 12px;\n  background: #ffffff;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.05);\n  transition: 0.25s;\n}\n\n/* Hover feel */\n.am-announcement:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 26px rgba(0, 0, 0, 0.08);\n}\n\n/* Active dot */\n.am-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #22c55e;\n  box-shadow: 0 0 0 4px rgba(34, 197, 94, 0.15);\n}\n\n/* Text */\n.am-announcement-text {\n  flex: 1;\n  font-size: 15px;\n  color: #111827;\n}\n\n/* Status badge */\n.am-status {\n  font-size: 12px;\n  font-weight: 600;\n  padding: 6px 10px;\n  border-radius: 999px;\n  background: #ecfdf5;\n  color: #16a34a;\n}\n\n/* INACTIVE */\n.am-announcement.inactive {\n  opacity: 0.6;\n}\n\n.am-announcement.inactive .am-dot {\n  background: #9ca3af;\n  box-shadow: none;\n}\n\n.am-announcement.inactive .am-status {\n  background: #f3f4f6;\n  color: #6b7280;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
